import { subtle } from "uncrypto"

export default async function hashString(val: string) {
  const msgBuffer = new TextEncoder().encode(val)
  const hashBuffer = await subtle.digest("SHA-256", msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray
    .map(b => b.toString(16).padStart(2, "0"))
    .join("")
}
